<template>
    <div>
        <Nag
            v-if="isImpersonating"
            :message="impersonatingMessage"
            :action="'//' + $root.urls.base + '?__unimpersonate'"
            verb="STOP"
            icon="fa fa-user-secret"
        />
        <Navigation></Navigation>
        <article>
            <router-view class="content"></router-view>
        </article>
    </div>
</template>
<script>
import Navigation from './nav.vue';

export default {
    name: 'AuthenticatedContainer',
    props: [
        'isSuperuser',
        'isTrialUser',
        'isOnboard',
        'isImpersonating',
        'impersonatingMessage'
    ],
    components: {
        Navigation: Navigation,
    }
}
</script>
